import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import StandardDropdown from "../components/widget/StandardDropdown"
import InfoIconHover from "../components/infoview/InfoIconHover"
import InfoDetail from "../components/infoview/InfoDetail"
import logo_white from '../assets/images/logo/chronos_HVIT_logo_CMYK.svg';
import axios from 'axios';
import Swal from 'sweetalert2';
import Spinner from 'react-bootstrap/Spinner';

const StartingPage = ({logout}) => {
    //Global variables
    //var selected_method = null
    const [selectedMethod, setSelectedMethod] = useState('');
    const [perplexity, setPerplexity] = useState('32');
    const [NNeighbours, setNNeighbours] = useState('15');
    const [minDistance, setMinDistance] = useState('0.01');
    const [organizations, setOrganizations] = useState(null);
    const [collections, setCollections] = useState(null);
    const [dataLoaded, setDataLoaded] = useState(null);
    const [dbStatusLoaded, setdbStatusLoaded] = useState(null);
    const [selectedDataset, setSelectedDataset] = useState("dataset_partition_vectors"); //useState(null);
    const showLogoutButton = false
    const [cacheStatus, setCacheStatus] = useState(null)
    const [dbNotEmpty, setdbNotEmpty] = useState(null)
    const [dimension, setDimension] = useState(null)
    const [method, setMethod] = useState(null)
    //const [organization, setOrganization] = useState(null)
    const [collection, setCollection] = useState(null)

    //const dimension = parseConfiguration("dimension")
    //const method = parseConfiguration("method")
    //const organization = parseConfiguration("organization")

    //axios.defaults.baseURL = "http://192.168.1.13:8096"
    //axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

    useEffect(() => {
        if (dimension && method && collection) {
            get_db_status(dimension, method, collection);
        }
    }, [dimension, method, collection]); 

    const get_db_status = () => {
        setCacheStatus(null);
        setdbNotEmpty(null);
        setdbStatusLoaded(false);
        const dataset = "partition_vectors"//parseConfiguration("dataset")
        const perplexity_val = get_detail_value("info_detail_perplexity", perplexity)
        const n_neighbours_val = get_detail_value("info_detail_n_neighbours", NNeighbours)
        const min_dist_val = get_detail_value("info_detail_min_dist", minDistance)

        const params = {
            dimension: dimension,
            method: method,
            dataset: dataset,
            perplexity: perplexity_val,
            n_neighbours: n_neighbours_val,
            min_dist: min_dist_val,
            collection: collection
        };

        axios.get('/api/get_db_status', { params })
        .then(response => {
            setCacheStatus(response.data["cache_status"] === 1)
            setdbNotEmpty(response.data["db_not_empty"] === 1)
            setdbStatusLoaded(true);
        })
        
        .catch(error => {
            setdbStatusLoaded(null);
            console.error('There was an error when calling get_db_status!', error);
            let msg = error.message || 'Unknown error';
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: msg,
            })
        .finally(() => {
        })
    })
    }

    const get_collections = () => { 
        if (collections === null) {
            fetch('/api/get_collections')
            .then(response => {
                if (!response.ok) {
                    // Throw an error if the response is not successful
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json(); // Parse the response as JSON
            })
            .then(data => {
                setCollections(data); // Update state with the fetched data
            })
            .catch(error => {
                console.error('There was an error fetching collections!', error);
                let msg = error.message || 'Unknown error'; // Use error message from the catch
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: msg,
                });
            })
            .finally(() => {
                setDataLoaded(true); // Ensure the loading state is updated
            });
        }
    };
    
    const get_organizations = () => { 
        if (organizations === null) {
            fetch('/api/get_organizations')
            .then(response => {
                if (!response.ok) {
                    // Throw an error if the response is not successful
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json(); // Parse the response as JSON
            })
            .then(data => {
                //data.push({ id: "all", val: "All organizations" }); // Add the additional item
                setOrganizations(data); // Update state with the fetched data
            })
            .catch(error => {
                console.error('There was an error fetching organizations!', error);
                let msg = error.message || 'Unknown error'; // Use error message from the catch
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: msg,
                });
            })
            .finally(() => {
                setDataLoaded(true); // Ensure the loading state is updated
            });
        }
    };

    const navigate = useNavigate();

    function parseConfiguration(type) {
        const dropdown_id = "dropdown_" + type;
        const dropdown = document.getElementById(dropdown_id)
        if (dropdown) {
            let selected_config = dropdown.getAttribute("data-selected")
            selected_config = selected_config.replace((type + "_"), "")
            return selected_config
        } else {
            return "-1"
        }
        
    }

    function parseDim(str) {
        switch(str) {
            case "2D":
                return "2"
            case "3D":
                return "3"
            default:
                return ""
          }
    }

    function parseMethod(str) {
        switch(str) {
            case "T-SNE":
                return "tsne"
            case "UMAP":
                return "umap"
            case "PCA":
                return "pca"
            default:
                return ""
          }
    }

    function parseDataset(str) {
        //Change this. This is vulnerable to title change
        switch(str) {
            case "Partition vectors":
                return "partition_vectors"
            case "20 newgroups dataset":
                return "20newsgroups"
            case "Valurank dataset":
                return "valurank"
            case "Wikipedia dataset":
                return "wikipedia"
            default:
                return ""
          }
    }

    const get_detail_value = (id, default_value) => {
        const detail_content = document.getElementById((id + "_content"))
        if (detail_content && detail_content.firstChild) {
            const content_inner = detail_content.firstChild
            if (content_inner.tagName === 'INPUT') {
                return content_inner.value
            } else {
                return content_inner.innerHTML
            }
        }
        return default_value
    }

    const dropdownOnSelect = (id, type) => {
        let selected_config = id.replace((type + "_"), "")
        if(type === "dimension") {
            setDimension(selected_config)
        } else if (type === "method") {
            setMethod(selected_config)
        } else if (type == "collection") {
            setCollection(selected_config)
        }
    }
    
    const toScatterPage = () => {
        const dataset = "partition_vectors"//parseConfiguration("dataset")
        const perplexity_val = get_detail_value("info_detail_perplexity", perplexity)
        const n_neighbours_val = get_detail_value("info_detail_n_neighbours", NNeighbours)
        const min_dist_val = get_detail_value("info_detail_min_dist", minDistance)

        const params_dict = {
            dimension: dimension,
            method: method,
            dataset: dataset,
            perplexity: perplexity_val,
            n_neighbours: n_neighbours_val,
            min_dist: min_dist_val,
            coll: collection
        };

        const params = new URLSearchParams(params_dict).toString();
    
        navigate(`/scatter-page?${params}`);
    };

    let dim_options = [{id: "dimension_2", val: "2D"}, {id: "dimension_3", val: "3D"}]
    let method_options = [{id: "method_tsne", val: "T-SNE"}, {id: "method_umap", val: "UMAP"}, {id: "method_pca", val: "PCA"}]
    let dataset_options = [{id: "dataset_partition_vectors", val: "Partition vectors"}, {id: "dataset_20newsgroups", val: "20 newgroups dataset"}, {id: "dataset_valurank", val: "Valurank dataset"}, {id: "dataset_wikipedia", val: "Wikipedia dataset"}]

    const addDetailExtend = () => {
        setTimeout(() => {
            var method_dropdown_items = document.getElementById("method-dropdown").querySelectorAll(".dropdown-item")
            method_dropdown_items.forEach(item => {
                var changeMethodDetails = () => {
                    let selected_method = item.id.replace("method_", "")
                    setSelectedMethod(selected_method)
                    let startpage_method_details = document.getElementById("startpage-method-details")
                    
                    if (selected_method === "pca") {
                        startpage_method_details.classList.remove('expanded')
                    } else {
                        startpage_method_details.classList.add('expanded')    
                    }
                }
                item.addEventListener('click', changeMethodDetails);
            });
        }, 0);
        
    }
    
    useEffect(() => {
        get_organizations();
        get_collections();
        console.log(collections);
        const dropdownElement = document.getElementById("dropdown_method");
        if (dropdownElement) {
            dropdownElement.onclick = addDetailExtend;
        }
        
        return () => {
            if (dropdownElement) {
                dropdownElement.onclick = null;
            }
        };
    })
    
    return (
        <main className="dark-centered-background" style={{position: "relative"}}>
            <img id="startpage-chronos-logo" src={logo_white} alt="White chronos-logo" />
            {showLogoutButton ? <div role='button' id="startpage-logout-button" onClick={logout}>Logout</div> : ""}
            {dataLoaded ? 
            <div className="configure-container">
            <div className="flex-column" style={{gap: "8px"}}>
                <h1 className="light no-margin">Embedding Visualization</h1>
                <h3 className="light no-margin">For plotting low-dimensionality embeddings</h3>
            </div>
            <form className="flex-column width-100" style={{gap: "17px"}}>
                <div className="flex-column" style={{gap: "8px"}}>
                    <div className="flex-row"  style={{gap: "10px"}}>
                        <InfoIconHover content="The number of features that the embeddings will be reduced to" size="l"/>
                        <h3 className="regular light">Dimension</h3>
                    </div>
                {<StandardDropdown id="dropdown_dimension" text="Choose dimension" options={dim_options} onSelect={(id) => dropdownOnSelect(id, "dimension")}/>}
                </div>
                <div id="method-dropdown" className="flex-column" style={{gap: "8px"}}>
                    <div className="flex-row"  style={{gap: "10px"}}>
                        <InfoIconHover content="The specific technique used for dimensionality reduction" size="l"/>
                        <h3 className="regular light">Method</h3>
                    </div>
                    {<StandardDropdown id="dropdown_method" text="Choose method" options={method_options} onSelect={(id) => dropdownOnSelect(id, "method")}/>}
                    <div style={{overflow: "hidden", position: "relative"}}>
                        <div id="startpage-method-details">
                            <div className='flex-column' style={{gap: "8px", padding: "0px 15px 20px 15px"}}>
                            {selectedMethod === "umap" && (
                                <>
                                    <InfoDetail 
                                    id="info_detail_n_neighbours" 
                                    title="Number of neighbours" 
                                    default_value={NNeighbours}  
                                    info="Controls how many data points are considered for the local neighborhood structure." 
                                    />
                                    <InfoDetail 
                                    id="info_detail_min_dist" 
                                    title="Minimum distance" 
                                    default_value={minDistance} 
                                    info="Sets the minimum spacing between points in the low-dimensional embedding, affecting clustering tightness." 
                                    />
                                </>
                                )}
                                {selectedMethod === "tsne" && (
                                <InfoDetail 
                                    id="info_detail_perplexity" 
                                    title="Perplexity" 
                                    default_value={perplexity} 
                                    info="Determines the effective number of neighbors considered for each point." 
                                />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex-column" style={{gap: "8px"}}>
                    {(selectedDataset === "dataset_partition_vectors")? 
                    (collections ? 
                    <>
                    <div className="flex-row"  style={{gap: "10px"}}>
                        <InfoIconHover content="The collection the partitions are coming from" size="l"/>
                        <h3 className="regular light">Collections</h3>
                    </div>
                    {<StandardDropdown id="dropdown_collection" text="Choose collection" options={collections} onSelect={(id) => dropdownOnSelect(id, "collection")}/>}
                    </>
                    : <span style={{color: "red"}}>There was an error when loading collections</span>)
                    : 
                    ""}
                </div>
                
            </form>
            {(dimension != null && method != null && collection != null)  && dbStatusLoaded != null ? (
                dbStatusLoaded ? (
                dbNotEmpty ? (
                cacheStatus ? (
                    <div className='flex-column' style={{gap: "8px"}}>
                    <div className='font-medium green' style={{wordBreak: "break-word", maxWidth: "377px"}}>Low dimensionality embeddings is stored are already generated</div>
                    <div role="button" className="standard-button" onClick={toScatterPage}>
                        <span className="font-large light homepage-button-txt">Show plot</span>
                    </div>
                    </div>
                    
                ) : (
                    <div className='flex-column' style={{gap: "8px"}}>
                    <div className='font-medium red' style={{wordBreak: "break-word", maxWidth: "377px"}}>Low dimensionality embeddings needs to be generated for the given configuration. This may take a couple of minutes </div>
                    <div role="button" className="standard-button" onClick={toScatterPage}>
                        <span className="font-large light homepage-button-txt">Show plot</span>
                    </div>
                    </div>
                )
                ) : <div className='font-medium red' style={{wordBreak: "break-word", maxWidth: "377px"}}>No partition vectors are available for the selected collection. Please choose a different one</div>
                ) : <div className='centered scatter-spinner-container'><Spinner animation="border" variant="primary" className='scatter-spinner small'/></div>
            ) : (
                ""
            )}
            
        </div>
        : 
        <div className='centered scatter-spinner-container'><Spinner animation="border" variant="primary" className='scatter-spinner large'/></div>
        } 
        </main>
    );
};

export default StartingPage;